import { Text, TextProps } from "@visx/text";

const ValueText = (props: TextProps) => {
  return (
    <Text
      textAnchor="middle"
      fill="#515151"
      fontSize={16}
      fontFamily={"'Work Sans', sans-serif"}
      fontWeight={500}
      {...props}
    />
  );
};

export default ValueText;
